enum ActionTypes {
  HIDE_CAMERA_SETTINGS_DIALOG = "app/cameraSettings/HIDE_CAMERA_SETTINGS_DIALOG",
  SHOW_CAMERA_SETTINGS_DIALOG = "app/cameraSettings/SHOW_CAMERA_SETTINGS_DIALOG",
}

export default ActionTypes;
